import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BeoButton } from "@components/common/action";
import getButtonModes from "@components/common/action/BeoButton/ButtonModeFactory";
import { BeoInputText } from "@components/common/input";
import { useState, useEffect, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
// Ambiguous characters (0/O, 1/l/I) removed for readability
var CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
var generateCaptcha = function () {
    var captcha = "";
    for (var i = 0; i < 6; i++) {
        captcha += CHARS.charAt(Math.floor(Math.random() * CHARS.length));
    }
    return captcha;
};
var BeoCaptcha = function (_a) {
    var onVerify = _a.onVerify, isFailed = _a.isFailed, onResetFail = _a.onResetFail, onInputChange = _a.onInputChange;
    var _b = useState(generateCaptcha), captcha = _b[0], setCaptcha = _b[1]; // lazy init
    var _c = useState(""), userInput = _c[0], setUserInput = _c[1];
    var canvasRef = useRef(null);
    // Draw captcha whenever it changes
    useEffect(function () {
        var canvas = canvasRef.current;
        var ctx = canvas === null || canvas === void 0 ? void 0 : canvas.getContext("2d");
        if (!canvas || !ctx)
            return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = "26px monospace";
        ctx.fillStyle = "#333";
        ctx.fillText(captcha, 10, 30);
        for (var i = 0; i < 4; i++) {
            ctx.strokeStyle = "rgba(0,0,0,".concat(Math.random(), ")");
            ctx.beginPath();
            ctx.moveTo(Math.random() * 100, Math.random() * 50);
            ctx.lineTo(Math.random() * 150, Math.random() * 50);
            ctx.stroke();
        }
    }, [captcha]);
    var refreshCaptcha = useCallback(function () {
        setCaptcha(generateCaptcha());
        setUserInput("");
        onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange("");
        onVerify(false);
    }, [onInputChange, onVerify]);
    // Reset captcha after a failed attempt
    useEffect(function () {
        if (isFailed) {
            refreshCaptcha();
            onResetFail === null || onResetFail === void 0 ? void 0 : onResetFail();
        }
    }, [isFailed, refreshCaptcha, onResetFail]);
    var handleVerify = function (e) {
        var value = e.target.value;
        setUserInput(value);
        onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(value);
        onVerify(value === captcha);
    };
    var t = useTranslation().t;
    var ButtonModes = getButtonModes(t);
    return (_jsxs("div", { className: "text-center my-4", children: [_jsxs("div", { className: "mt-2 flex items-center justify-center gap-2", children: [_jsx("canvas", { ref: canvasRef, width: 200, height: 50, role: "img", "aria-label": "CAPTCHA image", style: { border: "1px solid #ccc" } }), _jsx(BeoButton, { id: "refreshCaptcha", type: "button", onClick: refreshCaptcha, buttontype: ButtonModes.RefreshWithIcon })] }), _jsx("div", { className: "mt-2", children: _jsx(BeoInputText, { id: "captchaInput", placeholder: "Enter CAPTCHA", autoComplete: "off", value: userInput, onChange: handleVerify }) })] }));
};
export default BeoCaptcha;
